import { authedFetch } from '@/providers/loginWithEmail/dataProvider';
import { User } from '@/types';

/** Search active users by name/email; returns at most 5. */
export async function searchUsersByName(q: string): Promise<User[]> {
    const params = new URLSearchParams();
    if (q.trim()) {
        params.set('filter', JSON.stringify({ q: q.trim() }));
    }
    params.set('range', JSON.stringify([0, 5]));
    params.set('sort', JSON.stringify(['name', 'ASC']));
    const res = await authedFetch(`/users?${params.toString()}`);
    if (!res.ok) {
        throw new Error('Failed to search users');
    }
    return (await res.json()) as User[];
}
